module.exports = __webpack_public_path__ + "img/40_38_033_070.e8827e08.jpg";